import React, { useEffect, useContext, useState } from "react";

export const LockedPmcPopup = ({ title, description, visible, onClose, children }) => {
  
  useEffect(() => {
    document.body.style.overflow = visible ? "hidden" : "";
    return () => { document.body.style.overflow = ""; }
  }, [visible]);

  return (
    <div className="lockedpmc__popup"  style={{ display: visible ? "flex" : "none" }}>
      <div className={`lockedpmc__popup__inner ${visible ? "visible" : ""}`}>
        <header>
          <h3 className="lockedpmc__popup__heading">{title}</h3>
          <button
            className="lockedpmc__popup__close"
            aria-label="Close popup"
            onClick={onClose}
          />
        </header>

        <main>
          {description && (
            <div className="lockedpmc__popup__description_container">
              <h4 className="lockedpmc__popup__description">{description}</h4>
            </div>
          )}
          <div className="main popup__form-content" data-app-container="true">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
